import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteFromShuffleRequest } from './deletefromshufflerequest';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class DeleteFromShuffleAPI extends SixdeeCRBTAPI<DeleteFromShuffleRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod()
    {
        return POST;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/delete-from-shuffle
        return "delete-from-shuffle";
    }

    getRequestData()
    {
        return "clientTxnId=16072020"+"&"+
               "aPartyMsisdn=" + this.getRequest().getDeleteFromShuffleRequest().getAPartyMsisdn() +"&"+
               "toneIdList=[{\"toneId\":\""+this.getRequest().getDeleteFromShuffleRequest().getToneIdList() +"\"}]&"+
               "language="+ (this.getRequest().getDeleteFromShuffleRequest().getLanguage() === LanguageConst.ENGLISH ? "1": "2")+"&"+
               "priority="+ this.getRequest().getDeleteFromShuffleRequest().getPriority()+"&"+
               "channelId="+ this.getRequest().getDeleteFromShuffleRequest().getChannelId()+"&"+
               "timeType="+ this.getRequest().getDeleteFromShuffleRequest().getTimeType()+"&"+
               "activityId="+ this.getRequest().getDeleteFromShuffleRequest().getActivityId()+"&"+
               "serviceId=" + this.getRequest().getDeleteFromShuffleRequest().getServiceId(); 

               
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/deletefromshuffle/deletefromshuffleapi.tsx